import React, { Component } from 'react'
import { string, oneOfType, object } from 'prop-types'
import styled, { css } from 'styled-components'

const SubtTitleContainer = styled.span`
  font-size: 12px;
  color: ${({ color }) => color || '#333333'};
  line-height: ${({ lineHeight }) => lineHeight || '1.67'};
  font-weight: ${({ semibold }) => semibold ? '600' : 'normal'};
  ${({ noWrap }) => noWrap && css`
    white-space: nowrap;
  `}
  ${({ deleted }) => deleted && css`
    text-decoration: line-through;
  `}
`

export default class SubtTitle extends Component {
  static propTypes = {
    text: oneOfType([string, object])
  }
  static defaultProps = {
    text: ''
  }
  render () {
    const { text } = this.props
    return (
      <SubtTitleContainer {...this.props}>{ text }</SubtTitleContainer>
    )
  }
}
